import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import clsx from 'clsx';
import { Text } from '../Text/Text.js';
import styles from './Chip.module.css.js';

const Chip = ({ text, className, textStyle = 'caption', color = 'default', variant = 'outlined', style = 'pilled', }) => {
    return (jsxRuntimeExports.jsx("div", { className: clsx(styles.root, styles[color], styles[variant], styles[style], className), children: jsxRuntimeExports.jsx(Text, { type: textStyle, children: text }) }));
};

export { Chip };
//# sourceMappingURL=Chip.js.map
